/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for `/v2/hotel/free_night_match`. The user identity is
 * derived from the auth token; only the property ids the FE wants to
 * check are passed in. Cap at 200 ids per call (search-results pages).
 * 
 * Keyed on `vervotech_property_id` because that's the ID the FE
 * carries on every search result and hotel detail; the server joins
 * through `property_content` to find the per-chain attribute rows.
 * 
 * @export
 * @interface FreeNightMatchRequest
 */
export interface FreeNightMatchRequest {
    /**
     * vervotech_property_id values from the search/hotel-detail responses
     * @type {Array<number>}
     * @memberof FreeNightMatchRequest
     */
    vervotechPropertyIds: Array<number>;
}

/**
 * Check if a given object implements the FreeNightMatchRequest interface.
 */
export function instanceOfFreeNightMatchRequest(value: object): value is FreeNightMatchRequest {
    if (!('vervotechPropertyIds' in value) || value['vervotechPropertyIds'] === undefined) return false;
    return true;
}

export function FreeNightMatchRequestFromJSON(json: any): FreeNightMatchRequest {
    return FreeNightMatchRequestFromJSONTyped(json, false);
}

export function FreeNightMatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightMatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyIds': json['vervotech_property_ids'],
    };
}

export function FreeNightMatchRequestToJSON(json: any): FreeNightMatchRequest {
    return FreeNightMatchRequestToJSONTyped(json, false);
}

export function FreeNightMatchRequestToJSONTyped(value?: FreeNightMatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_ids': value['vervotechPropertyIds'],
    };
}

